import { useState } from 'react';
import PropTypes from 'prop-types';
import { CloseOutlinedCompIcon, InfoBoldCompIcon } from 'assets/icons';
import styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import routes from 'routes';

function BannerMessage({ text, type = 'danger', onClose }) {
  const [isOpen, setIsOpen] = useState(true);

  const handleCloseBtn = () => {
    onClose && onClose();
    setIsOpen(false);
  };

  if (isOpen === false) return null;

  return (
    <div className={`${styles.bannerMsg} ${styles[type]} workspaces`}>
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <span className={styles.infoIcon}>
            <InfoBoldCompIcon />
          </span>
          <div className='text'>{text}</div>
        </div>

        <div className='banner-message-actions-wrapper'>
          <Link
            className='btn banner-message-action-btn'
            href='/payment/package-upgrading'
            to={routes.packageUpgrade}
          >
            خرید و تمدید
          </Link>

          <span onClick={() => handleCloseBtn()}>
            <CloseOutlinedCompIcon className={styles.closeBtn} />
          </span>
        </div>
      </div>
    </div>
  );
}

BannerMessage.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['info', 'success', 'alert']),
};

export default BannerMessage;
